import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { TOP_CITIES } from '../constants'
import styles from './_routeSearchForm.css'

export default function TopCities () {
  return (
    <div className={styles.topCitiesContainer}>
      <Row>
        {Object.keys(TOP_CITIES).map((key, outerIdx) => {
          return (
            <Col md={4} xs={12} key={outerIdx}>
              {TOP_CITIES[key].map((city, innerIdx) => {
                return <a className={styles.topCity} key={innerIdx} href={city.url}>{city.name}</a>
              })}
            </Col>
          )
        })}
      </Row>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/routes/search/form/TopCities.jsx